import React, { useEffect, useState, } from 'react'
import {
    Button,
    Row,
    Col,
    Input,
    Form,
    Space,
    Tabs,
    Alert, message,
    Drawer,
    Table,
    Pagination
} from 'antd'
import '@/static/style/basetable.less'
import _, { get, set } from 'lodash'
import '@ant-design/pro-table/dist/table.css'
import { fetchInvoices } from '../api'
import { getColumns } from '../config'
import { outputMoney, getSid } from '@/public/utils'
import DateChoose from '@/compenents/newDateChoose'
import moment from 'moment'

const FormItem = Form.Item

const layout = {
    // labelCol: { span: 6 },
    // wrapperCol: { span: 23 }
}

const mutileEnterModal = (props) => {
    const { enums } = props
    const [form] = Form.useForm()
    const [open] = useState(true);
    const [tab, setTab] = useState('all');
    const [modalSelectRows, setModalSelectRows] = useState([])
    const [selectModalList, setSelectModalList] = useState([])
    const [loadingTable, setLoadingTable] = useState(false)
    const [time, setTime] = useState([])
    const [params, setParams] = useState({
        page_no: 1,
        page_size: 20,
        query: {}
    })


    // 查询
    const searchFun = async () => {
        const values = await form.validateFields()
        var bypersonArr = _.keys(get(enums, '发票类型枚举值(系统)'))
        const query = {
            ...values,
            sid: getSid(),
            invoice_source: bypersonArr.includes(props.type) ? "00" : "02",
            invoice_type: props.type,
            invoice_no_list: get(values, 'invoice_no_list') ? get(values, 'invoice_no_list').split(',') : [],
            invoice_date_start: get(time, '0') ? get(time, '0').format("YYYYMMDD") : moment().startOf('day').subtract(89, 'days').format("YYYYMMDD"),
            invoice_date_end: get(time, '1') ? get(time, '1').format("YYYYMMDD") : moment().endOf('day').format("YYYYMMDD"),
        }
        delete query.time
        searchFunAxios({ ...params, query,page_no: 1 })
    }

    const searchFunAxios = async (params) => {
        let { bills } = props
        try {
            setLoadingTable(true)
            let { data } = (await fetchInvoices(params)) || {}
            setTab('all')
            var list = sameChange(get(data, 'data.list'), bills, 'invoice_id')
            setSelectModalList(list)
            setParams({ ...params, total: get(data, 'data.total_count') })
            setLoadingTable(false)
        } catch (err) {
            console.log(err)
            setLoadingTable(false)
        }
    }


    const confirmSelect = async () => {
        const { setBill, setOpen } = props
        // if (!get(modalSelectRows, 'length')) {
        //     message.error('请选择发票')
        //     return
        // }
        setBill(modalSelectRows)
        setOpen(false)
    }

    const reload = () => {
        form.resetFields()
        _.defer(searchFun, 1000)
    }



    const selectModalRowSelection = {
        onChange: (allSelectedKeys, currentSelectedRows) => {
            const _arr = _.unionWith(
                _.differenceBy(modalSelectRows, selectModalList, 'invoice_id'),
                currentSelectedRows,
                (a, b) => { return a.invoice_id == b.invoice_id }
            )
            setModalSelectRows(_arr)
        },
        selectedRowKeys: modalSelectRows.map((i) => i.invoice_id),
        getCheckboxProps: record => ({
            name: record.name,
            disabled: record.is_occupy
        }),
    }

    const updateFun = (bills,delete_invoice_id) => {
        if(delete_invoice_id){
            setModalSelectRows(_.differenceBy(modalSelectRows, [{invoice_id:delete_invoice_id}], 'invoice_id'))
        }else{
            setSelectModalList(sameChange(selectModalList, bills, 'invoice_id'))
            setModalSelectRows(sameChange(modalSelectRows, bills, 'invoice_id'))
        }
    }

    const sameChange = (olds, news, key) => {
        return olds.map(old => {
            if (_.findIndex(news, [key, get(old, key)]) != -1) {
                return _.find(news, [key, get(old, key)])
            } else {
                return old
            }
        })
    }

    const modalPageChage = (page_no, page_size) => {
        set(params, 'page_no', page_no)
        set(params, 'page_size', page_size)
        setParams(params)
        searchFunAxios(params)
    }

    useEffect(() => {
        searchFun()
        setModalSelectRows(props.bills)
    }, [])

    return (
        <Drawer
            title="查询发票清单"
            width={1300}
            placement="right"
            className='scsDrawer'
            visible={open}
            onClose={() => { props.setOpen(false) }}
            footer={
                [
                    <Button type='primary' size='small' shape="round" onClick={confirmSelect}>确定选择</Button>,
                    <Button className='ml12' size='small'  shape="round" onClick={() => { props.setOpen(false) }}>取消</Button>
                ]
            }
        >
            <div>
                <section className='roundBorder '>
                    <Form form={form} >
                        <Row>
                                <FormItem name="time" initialValue={[]}>
                                    开票日期：
                                    <DateChoose
                                        defaultValue={'ninetyDays'}
                                        ifConvenient={true}
                                        isStatus={true}
                                        isClick={false}
                                        ifshowClear={true}
                                        time={true}
                                        timerChange={(data) => setTime(data)}
                                    />
                                </FormItem>
                            {
                                _.keys(get(enums, '发票类型枚举值(人工)')).includes(String(props.type))&&
                                <FormItem name="invoice_id" label='发票单号' initialValue={null}>
                                    <Input placeholder="请输入" allowClear style={{ width: 160,marginRight:'16px' }} />
                                </FormItem>
                            }
                                <FormItem name="invoice_no_list" label='发票号码'>
                                    <Input placeholder="多条查询请用英文逗号隔开" allowClear initialValue={''}  style={{ width: 230 }}/>
                                </FormItem>
                                <span style={{marginLeft:'40px'}}>
                                    <Button type="primary" onClick={searchFun}>
                                        查询
                                    </Button>
                                    <Button className='ml12' onClick={reload}>重置</Button>
                                </span>
                        </Row>
                    </Form>
                </section>
                <Alert message={<div>已选择匹配
                    <span className='ml4 mr4 blueFont'>{get(modalSelectRows, 'length') || 0}</span>
                    张发票，匹配金额合计：¥
                    <span className='ml4 mr4 blueFont'>
                        {
                            outputMoney(
                                _.reduce((modalSelectRows || []).map(item => item.match_invoice_amount), function (sum, n) {
                                    return sum + n;
                                }, 0))
                        }
                    </span>
                </div>
                }
                    type="info" showIcon />
                <Tabs activeKey={tab} onChange={(tab) => { setTab(tab) }}>
                    <Tabs.TabPane tab={<span>全部（{get(selectModalList, 'length')}）</span>} key="all">
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span>已选择（{get(modalSelectRows, 'length')}）</span>} key="seleted">
                    </Tabs.TabPane>
                </Tabs>
                {
                    tab == 'all' &&
                    <section style={{ overflow: 'hidden' }}>
                        <Table
                            className='mb12 littlePaddingTable'
                            bordered
                            rowSelection={selectModalRowSelection}
                            columns={getColumns({
                                enums, updateFun, bills: selectModalList, type: props.type, notneedDelete: 1,
                                selectedKeys: modalSelectRows.map(item => item.invoice_id)
                            })}
                            dataSource={selectModalList}
                            pagination={false}
                            loading={loadingTable}
                            scroll={{y:580}}
                            rowKey={record => record.invoice_id}
                        />
                        <div style={{ float: 'right', }}>
                            <Pagination
                                current={get(params, 'page_no')}
                                pageSize={get(params, 'page_size')}
                                showQuickJumper
                                showSizeChanger={true}
                                total={get(params, 'total') || 0}
                                onChange={modalPageChage}
                            />
                        </div>
                    </section>
                }
                {
                    tab == 'seleted' &&
                    <section style={{ overflow: 'hidden' }}>
                        <Table
                            className=' littlePaddingTable'
                            bordered
                            columns={getColumns({
                                enums, updateFun, bills: selectModalList, type: props.type,
                                selectedKeys: modalSelectRows.map(item => item.invoice_id)
                            })}
                            scroll={{y:580}}
                            dataSource={modalSelectRows}
                            pagination={false}
                            rowKey={record => record.invoice_id}
                        />
                    </section>
                }


            </div>
        </Drawer>
    )
}

export default mutileEnterModal


// WEBPACK FOOTER //
// ./src/pages/billVerification/match/detail/components/selectDrawer.js